<template>
  <template v-if="sucessEmailUpdated">
    <the-confirm-price-reservation :status="status" />
  </template>
  <template v-else-if="emailUpdated && status === 'loaded'">
    <the-email-already-update />
  </template>
  <div v-else>
    <!-- !emailUpdated && emailUpdated !== null &&  -->
    <div class="supplier-container d-flex" v-if="status === 'loaded'">
      <div
        v-for="(supplierName, index) in supplierData"
        :key="index"
        class="supplier-data p-8 ps-0 ps-xl-12 p-xl-12 w-100"
      >
        <div class="d-flex justify-content-between align-items-center accordion-toggle d-flex-wrap gx-12 w-100">
          <div class="td w-80">
            <div class="d-flex align-items-center">
              <div class="image-container rounded-sm bg-primary me-12">
                {{ capitalizeFirstLetter(supplierName.name) }}
              </div>

              <div class="py-4 fw-medium">{{ supplierName.name }}</div>
            </div>
          </div>
        </div>
        <div class="accordion-body collapse show p-0">
          <div class="resources-profit-header d-none d-lg-block">
            <div class="table-container">
              <div class="row-header d-flex w-100 text-sm">
                <div :class="isHotelSupplier(supplierName) ? 'th w-20' : 'th w-25'">
                  {{ $t("general.shared.name") }}
                </div>
                <div :class="isHotelSupplier(supplierName) ? 'w-10 th' : 'w-15 th'">{{ $t("general.shared.checkIn") }}</div>
                <div v-if="isHotelSupplier(supplierName)" class="w-10 th">{{ $t("general.shared.checkOut") }}</div>
                <div v-if="isHotelSupplier(supplierName)" class="w-10 th ps-0 ps-xxl-8 text-center">
                  {{ $t("tourPricing.nights") }}
                </div>
                <div :class="isHotelSupplier(supplierName) ? 'w-10 th text-center' : 'w-15 th text-center'">{{ $t("general.shared.quantityShort") }}</div>
                <div :class="isHotelSupplier(supplierName) ? 'w-20 th text-center' : 'w-20 th text-center'">{{ $t("tourPricing.netPrice") }}/{{ $t("general.shared.unit") }}</div>
                <div :class="isHotelSupplier(supplierName) ? 'w-20 th' : 'w-25 th'">{{ $t("travelBook.totalPrice") }}</div>
              </div>
              <template v-for="(item, index) in supplierName.suppliers" :key="index">
                <div
                  v-for="(newItem, itemResourceIndex) in item.itemResourcesGrouped"
                  :key="itemResourceIndex"
                  class="wrapper"
                  :class="{ 'bg-gray-200': itemResourceIndex % 2 !== 0 }"
                >
                  <div class="row-data d-flex w-100">
                    <div :class="isHotelSupplier(supplierName) ? 'th w-20 d-flex flex-column product-info' : 'th w-25 d-flex flex-column product-info'">
                      <div>
                        <span>{{ supplierNameByLange(newItem?.translations) }}</span>
                      </div>
                      <template v-if="newItem?.clientObservations">
                        <span class="p-16" v-html="newItem?.clientObservations" />
                      </template>
                    </div>
                    <div :class="isHotelSupplier(supplierName) ? 'w-10 th product-info' : 'w-15 th product-info'">
                      {{ $str.formatDateTime(newItem.date, settings.formatDate) }}
                    </div>
                    <div v-if="isHotelSupplier(supplierName)" class="w-10 th product-info">
                      {{ $str.formatDateTime(newItem.endDate, settings.formatDate) }}
                    </div>
                    <div v-if="isHotelSupplier(supplierName)" class="th w-10 product-info text-center">
                      <span class="w-100">
                        {{ calculateNights(newItem.date, newItem.endDate) }}
                      </span>
                    </div>
                    <div :class="isHotelSupplier(supplierName) ? 'w-10 th product-info text-center' : 'w-15 th product-info text-center'">
                      <span class="w-100">
                        {{ newItem.quantity }}
                      </span>
                    </div>
                    <div class="w-20 th product-info text-center">
                      <template v-if="showModificationPrice">
                        <v-form-input
                          id="pricing-net-price"
                          v-model="newItem.netPrice"
                          autocomplete="off"
                          form-type="input-group"
                          min="0"
                          onwheel="return false;"
                          right-addon="€"
                          step=".01"
                          type="number"
                          :class="{ 'custom-input-style': showModificationPrice }"
                        />
                      </template>
                      <template v-else>
                        <span class="w-100">
                          {{ newItem.netPrice }}
                        </span>
                      </template>
                    </div>
                    <div :class="isHotelSupplier(supplierName) ? 'w-20 th product-info' : 'w-25 th product-info'">
                      <v-form-input
                        id="pricing-net-price"
                        :modelValue="roundPrice(newItem.netPrice * newItem.quantity)"
                        disabled="true"
                        autocomplete="off"
                        form-type="input-group"
                        onwheel="return false;"
                        right-addon="€"
                        step=".01"
                        type="number"
                      />
                    </div>
                    <div
                      v-if="newItem.resources.length > 1"
                      :aria-controls="`collapse-tour-day-item-resource-${newItem.id}-dropdown`"
                      :data-bs-target="`#collapse-tour-day-item-resource-${newItem.id}-dropdown`"
                      aria-expanded="false"
                      class="accordion-toggle collapsed"
                      data-bs-toggle="collapse"
                    >
                      <v-icon class="accordion-icon" icon="chevron-up" size="xl" />
                    </div>
                  </div>
                  <div
                    v-if="newItem.resources.length > 1"
                    :id="`collapse-tour-day-item-resource-${newItem.id}-dropdown`"
                    class="accordion-body collapse p-0 accordion-sub-body"
                  >
                    <div
                      v-for="(newResource, index) in newItem.resources"
                      :key="index"
                      class="row-data d-flex w-100 dashed"
                    >
                      <div :class="isHotelSupplier(supplierName) ? 'th w-20 d-flex flex-column product-info' : 'th w-25 d-flex flex-column product-info'">
                        <div>
                          <span>{{ supplierNameByLange(newResource?.translations) }}</span>
                        </div>
                        <template v-if="newResource?.clientObservations">
                          <div class="text-muted" v-html="newResource?.clientObservations" />
                        </template>
                      </div>
                      <div :class="isHotelSupplier(supplierName) ? 'w-10 th product-info' : 'w-15 th product-info'">
                        {{ $str.formatDateTime(newResource.date, settings.formatDate) }}
                      </div>
                      <div v-if="isHotelSupplier(supplierName)" class="w-10 th product-info">
                        {{ $str.formatDateTime(newResource.endDate, settings.formatDate) }}
                      </div>
                      <div v-if="isHotelSupplier(supplierName)" class="th w-10 product-info text-center">
                        <span class="w-100">
                          {{ calculateNights(newResource.date, newResource.endDate) }}
                        </span>
                      </div>
                      <div :class="isHotelSupplier(supplierName) ? 'w-10 th product-info text-center' : 'w-15 th product-info text-center'">
                        <span class="w-100">
                          {{ newResource.quantity }}
                        </span>
                      </div>
                      <div class="w-20 th product-info text-center">
                        <template v-if="showModificationPrice">
                          <v-form-input
                            id="pricing-net-price"
                            :value="newItem.netPrice"
                            autocomplete="off"
                            form-type="input-group"
                            onwheel="return false;"
                            right-addon="€"
                            step=".01"
                            type="number"
                            disabled
                          />
                        </template>
                        <template v-else>
                          <span class="w-100">
                            {{ newResource.netPrice }}
                          </span>
                        </template>
                      </div>
                      <div :class="isHotelSupplier(supplierName) ? 'w-20 th product-info' : 'w-25 th product-info'">
                        <v-form-input
                          id="pricing-net-price"
                          :modelValue="roundPrice(newItem.netPrice * newResource.quantity)"
                          :disabled="true"
                          autocomplete="off"
                          form-type="input-group"
                          onwheel="return false;"
                          right-addon="€"
                          step=".01"
                          type="number"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="d-lg-none">
            <div class="table-container">
              <template v-for="(item, index) in supplierName.suppliers" :key="index">
                <template v-for="(newItem, index) in item.itemResourcesGrouped" :key="index">
                  <div class="w-100 mb-16">
                    <div class="d-flex flex-column align-items-start fw-semi py-4">
                      <div>
                        <span>{{ $t("general.shared.name") }}:</span>
                        <span>{{ supplierNameByLange(newItem?.translations) }}</span>
                      </div>
                      <template v-if="newItem?.clientObservations">
                        <span class="text-muted" v-html="newItem?.clientObservations" />
                      </template>
                    </div>
                    <div class="d-flex align-items-center fw-semi py-4">
                      <span>{{ $t("general.shared.checkIn") }}:</span>
                      <span> {{ $str.formatDateTime(newItem.date, settings.formatDate) }}</span>
                    </div>
                    <div v-if="isHotelSupplier(supplierName)" class="d-flex align-items-center fw-semi py-4">
                      <span>{{ $t("general.shared.checkOut") }}:</span>
                      <span>{{ $str.formatDateTime(newItem.endDate, settings.formatDate) }}</span>
                    </div>
                    <div v-if="isHotelSupplier(supplierName)" class="d-flex align-items-center fw-semi py-4">
                      <span> {{ $t("tourPricing.nights") }}:</span>
                      <span>{{ calculateNights(newItem.date, newItem.endDate) }}</span>
                    </div>
                    <div class="d-flex align-items-center fw-semi py-4">
                      <span>{{ $t("general.shared.quantityShort") }}:</span>
                      <span>{{ newItem.quantity }}</span>
                    </div>
                    <template v-if="showModificationPrice">
                      <div class="d-flex flex-column align-items-start fw-semi py-4">
                        <span>{{ $t("tourPricing.netPrice") }}/{{ $t("general.shared.unit") }}:</span>
                        <span class="w-100">
                          <v-form-input
                            id="pricing-net-price"
                            v-model="newItem.netPrice"
                            autocomplete="off"
                            form-type="input-group"
                            min="0"
                            onwheel="return false;"
                            right-addon="€"
                            step=".01"
                            type="number"
                          />
                        </span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="d-flex align-items-center fw-semi py-4">
                        <span>{{ $t("tourPricing.netPrice") }}/{{ $t("general.shared.unit") }}:</span>
                        <span>
                          {{ newItem.netPrice }}
                        </span>
                      </div>
                    </template>
                    <div class="d-flex flex-column align-items-start fw-semi py-4">
                      <span>{{ $t("travelBook.totalPrice") }}:</span>
                      <span class="w-100">
                        <v-form-input
                          id="pricing-net-price"
                          :modelValue="roundPrice(newItem.netPrice * newItem.quantity)"
                          disabled="true"
                          autocomplete="off"
                          form-type="input-group"
                          onwheel="return false;"
                          right-addon="€"
                          step=".01"
                          type="number"
                        />
                      </span>
                    </div>
                    <div
                      v-if="newItem.resources.length > 1"
                      :aria-controls="`collapse-tour-day-item-resource-${newItem.id}-dropdown`"
                      :data-bs-target="`#collapse-tour-day-item-resource-${newItem.id}-dropdown`"
                      aria-expanded="false"
                      class="accordion-toggle collapsed"
                      data-bs-toggle="collapse"
                    >
                      <v-icon class="accordion-icon" icon="chevron-up" size="xl" />
                    </div>
                  </div>
                  <div
                    v-if="newItem.resources.length > 1"
                    :id="`collapse-tour-day-item-resource-${newItem.id}-dropdown`"
                    class="accordion-body collapse p-0 accordion-sub-body"
                  >
                    <template v-for="(newResource, index) in newItem.resources" :key="index">
                      <div class="w-100 mb-16">
                        <div class="d-flex flex-column align-items-start fw-semi py-4">
                          <div>
                            <span>{{ $t("general.shared.name") }}:</span>
                            <span>{{ supplierNameByLange(newResource?.translations) }}</span>
                          </div>
                          <template v-if="newResource?.clientObservations">
                            <span class="text-muted" v-html="newResource?.clientObservations" />
                          </template>
                        </div>
                        <div class="d-flex align-items-center fw-semi py-4">
                          <span>{{ $t("general.shared.checkIn") }}:</span>
                          <span> {{ $str.formatDateTime(newResource.date, settings.formatDate) }}</span>
                        </div>
                        <div v-if="isHotelSupplier(supplierName)" class="d-flex align-items-center fw-semi py-4">
                          <span>{{ $t("general.shared.checkOut") }}:</span>
                          <span>{{ $str.formatDateTime(newResource.endDate, settings.formatDate) }}</span>
                        </div>
                        <div v-if="isHotelSupplier(supplierName)" class="d-flex align-items-center fw-semi py-4">
                          <span> {{ $t("tourPricing.nights") }}:</span>
                          <span>{{ calculateNights(newResource.date, newResource.endDate) }}</span>
                        </div>
                        <div class="d-flex align-items-center fw-semi py-4">
                          <span>{{ $t("general.shared.quantityShort") }}:</span>
                          <span>{{ newResource.quantity }}</span>
                        </div>
                        <template v-if="showModificationPrice">
                          <div class="d-flex flex-column align-items-start fw-semi py-4">
                            <span>{{ $t("tourPricing.netPrice") }}/{{ $t("general.shared.unit") }}:</span>
                            <span class="w-100">
                              <v-form-input
                                id="pricing-net-price"
                                v-model="newResource.netPrice"
                                autocomplete="off"
                                form-type="input-group"
                                onwheel="return false;"
                                right-addon="€"
                                step=".01"
                                type="number"
                              />
                            </span>
                          </div>
                        </template>
                        <template v-else>
                          <div class="d-flex align-items-center fw-semi py-4">
                            <span>{{ $t("tourPricing.netPrice") }}/{{ $t("general.shared.unit") }}:</span>
                            <span>
                              {{ newResource.netPrice }}
                            </span>
                          </div>
                        </template>
                        <div class="d-flex flex-column align-items-start fw-semi py-4">
                          <span>{{ $t("travelBook.totalPrice") }}:</span>
                          <span class="w-100">
                            <v-form-input
                              id="pricing-net-price"
                              :modelValue="roundPrice(newResource.netPrice)"
                              disabled="true"
                              autocomplete="off"
                              form-type="input-group"
                              onwheel="return false;"
                              right-addon="€"
                              step=".01"
                              type="number"
                            />
                          </span>
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
                <hr />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="free-text" v-if="showModificationText">
      <v-form-input
        label="Free text"
        id="supplier-observation"
        autocomplete="off"
        v-model="supplierObservation"
        class="mb-24"
        form-type="outline"
        input-type="textarea"
        label-class="text-sm"
        rows="5"
        autofocus
        :class="{ 'custom-input-style': showModificationText }"
      />
    </div>
    <!-- !emailUpdated && emailUpdated !== null &&  -->
    <div class="supplier-container d-flex justify-content-end gap-12 p-32" v-if="status === 'loaded'">
      <div class="btn-container">
        <div class="row-header d-flex w-100 text-sm">
          <div class="th w-20">
            <div class="d-flex">
              <template v-if="showModificationText">
                <v-button
                  class="btn-save-confirm text-center cursor-pointer"
                  size="sm"
                  @click="confirm('freeText')"
                >
                  {{ $t("general.button.save") }} & {{ $t("general.button.confirm") }}
                </v-button>
              </template>
              <template v-else>
                <v-button
                  class="btn-modify text-center cursor-pointer"
                  size="sm"
                  :disabled="showModificationPrice"
                  :title='$t("general.shared.editFreeTextWarning")'
                  @click="acceptModification"
                >
                  {{ $t("general.shared.modification") }}
                </v-button>
              </template>
            </div>
          </div>
          <div class="w-10 th"></div>
          <div class="w-10 th"></div>
          <div class="w-10 th ps-0 ps-xxl-8 text-center"></div>
          <div class="w-10 th text-center"></div>
          <div class="w-20">
            <div class="d-flex justify-content-center gap-8">
              <template v-if="showModificationPrice">
                <v-button
                  class="btn-accept text-center cursor-pointer"
                  size="sm"
                  @click="confirmAccept"
                >
                  {{ $t("general.shared.accept") }}
                </v-button>
                <v-button
                  class="btn-save-confirm text-center cursor-pointer"
                  size="sm"
                  @click="checkPriceValue"
                >
                  {{ $t("general.button.save") }} & {{ $t("general.button.confirm") }}
                </v-button>
              </template>
              <template v-else>
                <v-button
                  class="btn-accept text-center cursor-pointer"
                  size="sm"
                  @click="confirmAccept"
                >
                  {{ $t("general.shared.accept") }}
                </v-button>
                <v-button
                  class="btn-edit-price text-center cursor-pointer"
                  size="sm"
                  :disabled="showModificationText"
                  :title='$t("general.shared.editPriceWarning")'
                  @click="accept"
                >
                  {{ $t("general.shared.editPrice") }}
                </v-button>
              </template>
            </div>
          </div>
          <div class="w-20 th text-end">
            <v-button
              v-if="showModificationText || showModificationPrice"
              class="btn-icon w-fit align-self-end"
              size="sm"
              variant="primary"
              @click="goBack"
            >
              {{ $t("uploader.goBack") }}
              <v-icon icon="arrow-right" size="sm" space="ms-12" />
            </v-button>
          </div>
        </div>
      </div>
      <div class="d-lg-none w-100 d-flex justify-content-between">
        <div>
          <v-button
            v-if="showModificationText || showModificationPrice"
            class="btn-icon w-fit align-self-end"
            size="sm"
            variant="primary"
            @click="goBack"
          >
            {{ $t("uploader.goBack") }}
            <v-icon icon="arrow-right" size="sm" space="ms-12" />
          </v-button>
        </div>
        <div class="d-flex gap-12">
          <div class="d-flex">
            <template v-if="showModificationText">
              <v-button
                class="btn-save-confirm text-center button-container cursor-pointer"
                size="sm"
                @click="confirm('freeText')"
              >
                {{ $t("general.button.save") }} & {{ $t("general.button.confirm") }}
              </v-button>
            </template>
            <template v-else>
              <v-button
                class="btn-modify text-center button-container cursor-pointer"
                size="sm"
                :title='$t("general.shared.editFreeTextWarning")'
                @click="acceptModification"
              >
                {{ $t("general.shared.modification") }}
              </v-button>
            </template>
          </div>
          <div class="d-flex">
            <template v-if="showModificationPrice">
              <v-button
                class="btn-accept text-center button-container cursor-pointer"
                size="sm"
                @click="confirmAccept"
              >
                {{ $t("general.shared.accept") }}
              </v-button>
              <v-button
                class="btn-save-confirm text-center button-container cursor-pointer"
                size="sm"
                @click="checkPriceValue"
              >
                {{ $t("general.button.save") }} & {{ $t("general.button.confirm") }}
              </v-button>
            </template>
            <template v-else>
              <v-button
                class="btn-accept text-center button-container cursor-pointer"
                size="sm"
                @click="confirmAccept"
              >
                {{ $t("general.shared.accept") }}
              </v-button>
              <v-button
                class="btn-edit-price text-center button-container cursor-pointer"
                size="sm"
                :title='$t("general.shared.editPriceWarning")'
                @click="accept"
              >
                {{ $t("general.shared.editPrice") }}
              </v-button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- !emailUpdated && emailUpdated !== null &&  -->
    <the-editable-info-modal v-if="showModal && status === 'loaded'" @closed="closeModal" />
    <the-email-warning-modal
      v-if="showWarningModal"
      :price-warning="showPriceWarning"
      :free-text-warning="showFreeTextWarning"
      @closed="closeWarningModal"
    />
    <v-modal
      id="show-check-0-price-modal"
      class-name="modal-fullscreen-sm-down"
      v-if="showPricingConfirmation"
      size="lg"
      @closed="showPricingConfirmation = false"
    >
      <modal-header>
        <modal-title>{{ $t("emailTemplate.email_warning") }}</modal-title>
      </modal-header>
      <modal-body>
        <div>
          {{ $t("emailTemplate.price_warning") }}
        </div>
      </modal-body>
      <modal-footer>
        <v-button
          class="btn-sm btn-success align-self-end cursor-pointer"
          size="sm"
          variant="success"
          @click="confirm('price')"
        >
          {{ $t("general.button.ok") }}
        </v-button>
      </modal-footer>
    </v-modal>
  </div>
</template>

<script setup lang="ts" name="TheCaseModificationContent">
import _, { cloneDeep } from "lodash";
import { onMounted, ref } from "vue";
import { VFormInput } from "@uniqoders/form";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import { useAppStore } from "@/stores/app";
import api from "@/api";
import TheConfirmPriceReservation from "@/components/email/TheConfirmPriceReservation.vue";
import TheEmailAlreadyUpdate from "@/components/email/TheEmailAlreadyUpdate.vue";
import TheEditableInfoModal from "@/components/email/TheEditableInfoModal.vue";
import TheEmailWarningModal from "@/components/email/TheEmailWarningModal.vue";
import VModal from "@/components/vendor/basic/modal/VModal.vue";
import ModalHeader from "@/components/vendor/basic/modal/ModalHeader.vue";
import ModalTitle from "@/components/vendor/basic/modal/ModalTitle.vue";
import ModalBody from "@/components/vendor/basic/modal/ModalBody.vue";
import ModalFooter from "@/components/vendor/basic/modal/ModalFooter.vue";
import TourDayItemResource from "@/api/objects/TourDayItemResource";
import { useRoute } from "vue-router";
import { IPricingItemSupplierResource } from "./case/parts/TheTourPricing.vue";
import { calculatePriceGroup, roundPrice } from "@/composables/pricing";
import { storeToRefs } from "pinia";
import { DateTime } from "luxon";
import { useToast } from "vue-toastification";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const toast = useToast();
const route = useRoute();
const appStore = useAppStore();
const { settings } = storeToRefs(appStore);
const showModificationPrice = ref(false);
const showModificationText = ref(false);
const supplierData = ref({});
const supplierDataBackup = ref({});
const supplierObservation = ref("");
const status = ref("loading");
const sucessEmailUpdated = ref(false);
const emailUpdated = ref(null);

const showModal = ref(true);
const showWarningModal = ref(false);
const showPriceWarning = ref(false);
const showFreeTextWarning = ref(false);
const showPricingConfirmation = ref(false);

onMounted(async () => {
  status.value = "loading";
  await emailInfoPricing();
  status.value = "loaded";
});

const closeModal = () => {
  showModal.value = false;
};

const closeWarningModal = () => {
  showWarningModal.value = false;
  showPriceWarning.value = false;
  showFreeTextWarning.value = false;
};

const acceptModification = async () => {
  showModificationText.value = true;
};

const goBack = () => {
  supplierData.value = supplierDataBackup.value;
  supplierObservation.value = "";

  showModificationText.value = false;
  showModificationPrice.value = false;
};

const checkPriceValue = () => {
  const hasZeroSupplierPrice = supplierData.value?.[0]?.suppliers?.some((supplier: any) =>
    supplier.itemResourcesGrouped?.some((item: any) => item.netPrice === 0)
  );

  if (hasZeroSupplierPrice) {
    showPricingConfirmation.value = true;
  } else {
    confirm("price");
  }
};

const accept = async () => {
  showModificationPrice.value = true;
};

const supplierNameByLange = (lang: any) => {
  const language = localStorage.getItem("language");
  const filterLangName = lang?.find((item: any) => item.locale === language);
  return filterLangName?.name || "";
};

const calculateNights = (initDate: any, endDate: any) => {
  if (!initDate || !endDate) {
    return 0;
  }

  const init = DateTime.fromISO(initDate).startOf("day");
  const end = DateTime.fromISO(endDate).startOf("day");

  return end.diff(init, "days").days;
};

const capitalizeFirstLetter = (str?: string): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase();
};

const emailInfoPricing = async () => {
  const { caseid, token, resources } = route.query;
  const resourceIds = typeof resources === "string" ? resources.split(",").map(Number) : [];

  if (caseid) {
    const payload = {
      resourceIds,
    };
    const res = await api.case.fetchModification(caseid, token, payload);
    const gropDAta = res?.content;

    // Step 1: Sort data
    const sortedData = _.sortBy(gropDAta, (item) => item.start_date);

    // Step 2: Group by type
    const groupedByType = _.groupBy(sortedData, (item) => item.type || "unknown");

    // Step 3: Sort types (hotel first)
    const sortedTypes = Object.keys(groupedByType).sort((a, b) => {
      if (a === "hotel") return -1;
      if (b === "hotel") return 1;
      return a.localeCompare(b);
    });

    const pricingItems = sortedTypes
      .map((name) => {
        const caseDayItems = _.sortBy(groupedByType[name], (item) => item.start_date);
        const { netPrice, grossPrice, markup } = calculatePrice(caseDayItems);

        // ---- Supplier Grouping ----
        const supplierGroups: { [key: string]: TourDayItemResource[] } = {};
        for (const item of caseDayItems) {
          if (!item.item_data) continue;
          const supplier = item.item_data;

          const key = supplier.type === "hotel" ? `${supplier.id}-${item.case_day_id}` : `${supplier.id}`;
          (supplierGroups[key] ||= []).push(item);
        }

        const suppliersMapped = Object.values(supplierGroups)
          .map((groupItems) => {
            const firstItem = groupItems[0];
            const supplier = firstItem.item_data;

            // skip if NO resources at all across the group
            const anyResources = groupItems.some(
              (it) => Array.isArray(it.case_day_item_resources) && it.case_day_item_resources.length > 0
            );
            if (!anyResources) return null;

            const makeGroupKey = (parentItem: any, resource: any) => {
              const resPayment = resource?.payment_status ?? parentItem?.payment_status ?? "";
              const resBooking = resource?.booking_status ?? parentItem?.booking_status ?? "";
              const resInvoice = resource?.invoice_status ?? parentItem?.invoice_status ?? "";
              const itemType = parentItem.type ?? parentItem.item_data?.type ?? "";
              const supplierResId = resource?.supplier_resource?.id ?? resource?.supplier_resource_id ?? "";

              if (itemType === "hotel") {
                // Hotels: group only when room type, checkin, checkout, net_price, and statuses all match
                const resStart = resource?.checkin_date ?? parentItem?.checkin_date ?? "";
                const checkin = resource?.checkin_date ?? parentItem?.checkin_date;
                const nights = resource?.nights ?? parentItem?.nights ?? 0;
                const resEnd = (checkin && nights)
                  ? DateTime.fromISO(checkin).plus({ days: nights }).toISODate()
                  : "";
                const resNet = roundPrice(resource?.net_price ?? parentItem?.net_price ?? 0);
                return `${supplierResId}-${resStart}-${resEnd}-${resNet}-${resPayment}-${resBooking}-${resInvoice}`;
              }

              if (itemType === "transfer" || itemType === "transport" || itemType === "luggage_transport") {
                // Transfers/transport/luggage: allow grouping across multiple dates, same resource + statuses
                return `${supplierResId}-${resPayment}-${resBooking}-${resInvoice}`;
              }

              // Other services: group by same resource + same checkin date + same statuses
              const resStart = resource?.checkin_date ?? parentItem?.checkin_date ?? "";
              return `${supplierResId}-${resStart}-${resPayment}-${resBooking}-${resInvoice}`;
            };

            const groupMap: Record<string, any[]> = {};

            for (const parentItem of groupItems) {
              const resources = parentItem.case_day_item_resources ?? [];
              for (const res of resources) {
                const key = makeGroupKey(parentItem, res);
                (groupMap[key] ||= []).push({ parentItem, resource: res });
              }
            }

            const itemResourcesGrouped = Object.values(groupMap).map((bucket) => {
              const dates = bucket
                .map((b: any) => b.resource?.checkin_date ?? b.parentItem?.checkin_date)
                .filter(Boolean);
              const date = dates.length ? dates.sort()[0] : null;
              const endDates = bucket
                .map((b: any) => {
                  const checkout = b.resource?.checkout_date ?? b.parentItem?.checkout_date;
                  if (checkout) return checkout;
                  const checkin = b.resource?.checkin_date ?? b.parentItem?.checkin_date;
                  const nights = b.resource?.nights ?? b.parentItem?.nights ?? 0;
                  if (checkin && nights) {
                    return DateTime.fromISO(checkin).plus({ days: nights }).toISODate();
                  }
                  return null;
                })
                .filter(Boolean);
              const endDate = endDates.length ? endDates.sort()[0] : null;

              const mappedResources = _.sortBy(
                bucket.map(({ parentItem, resource }: any) => ({
                  id: resource.id,
                  netPrice: roundPrice(resource.net_price),
                  netValidated: !!(resource.is_price_validated ?? parentItem.is_price_validated),
                  isUpdatedBySupplier: !!(resource.is_updated_by_supplier ?? false),
                  reservationStatus: resource.booking_status ?? parentItem.booking_status,
                  invoiceStatus: resource.invoice_status ?? parentItem.invoice_status,
                  paymentStatus: resource.payment_status ?? parentItem.payment_status,
                  notes: resource.notes ?? parentItem.notes ?? null,
                  supplierResource: resource.supplier_resource ?? {
                    id: resource.supplier_resource_id ?? null,
                    name: resource.supplier_resource?.name ?? parentItem.item_data?.name ?? null,
                    type: resource.supplier_resource?.type ?? parentItem.item_data?.type ?? null,
                  },
                  supplierResourceName: resource.supplier_resource?.name ?? parentItem.item_data?.name ?? null,
                  date: resource.checkin_date ?? parentItem.checkin_date ?? null,
                  endDate: resource.checkout_date
                    ?? parentItem.checkout_date
                    ?? (resource.checkin_date && resource.nights
                      ? DateTime.fromISO(resource.checkin_date).plus({ days: resource.nights }).toISODate()
                      : (parentItem.checkin_date && parentItem.nights
                        ? DateTime.fromISO(parentItem.checkin_date).plus({ days: parentItem.nights }).toISODate()
                        : null)),
                  quantity: 1,
                  paxes:
                    (resource?.paxes || [])
                      ?.map((p: any) => p.pax?.name || p.name) || [],
                  translations: resource?.supplier_resource?.translations,
                  __raw: { resource, parentItem },
                })),
                (r) => r.date ?? ""
              );

              const totalNetPrice = roundPrice(_.sumBy(mappedResources, "netPrice"));
              // netPrice is the per-unit price (total divided by quantity),
              // totalNetPrice is the sum across all resources in the group.
              // The total price column displays netPrice * quantity.
              const unitNetPrice = bucket.length > 0 ? roundPrice(totalNetPrice / bucket.length) : 0;

              return {
                date,
                endDate,
                resources: mappedResources,
                translations: mappedResources[0]?.translations,
                paxes: mappedResources.flatMap((r: any) => r.paxes || []) as string[],
                supplierResourceId: mappedResources[0]?.supplierResource?.id ?? null,
                name: mappedResources[0]?.supplierResource?.name ?? supplier.name,
                type: mappedResources[0]?.supplierResource?.type ?? supplier.type,
                quantity: bucket.length,
                totalNetPrice,
                netPrice: unitNetPrice,
                paymentStatus: mappedResources[0]?.paymentStatus ?? null,
                reservationStatus: mappedResources[0]?.reservationStatus ?? null,
                invoiceStatus: mappedResources[0]?.invoiceStatus ?? null,
                netValidated: mappedResources[0]?.netValidated ?? false,
                tourDayItemResourceIds: bucket.map((b: any) => b.resource.id),
                caseDayId: bucket[0].parentItem.case_day_id,
                caseDayItemId: bucket[0].parentItem.id,
              };
            });

            return {
              ...supplier,
              invoiceChecked: false,
              itemResourcesGrouped: _.sortBy(itemResourcesGrouped, (r) => r.date ?? ""),
              totalNetPrice: _.sumBy(itemResourcesGrouped, "totalNetPrice"),
              netValidated: itemResourcesGrouped[0]?.netValidated,
              paymentStatus: itemResourcesGrouped[0]?.paymentStatus,
              invoicePaymentStatus: itemResourcesGrouped.every((r) => r.paymentStatus === "complete")
                ? "complete"
                : "pending",
              reservationStatus: itemResourcesGrouped[0]?.reservationStatus,
              invoiceStatus: itemResourcesGrouped[0]?.invoiceStatus,
              type: supplier.type,
              name: supplier.name,
              caseDayId: firstItem.case_day_id,
              caseDayItemId: firstItem.id,
              note: firstItem.note,
              paxes: firstItem.paxes,
            };
          })
          .filter(Boolean);

        // Sort suppliers by earliest date
        const sortedSuppliers = _.sortBy(suppliersMapped, (s) => s.itemResourcesGrouped?.[0]?.date);

        // Only include this pricing item if there are valid suppliers
        if (sortedSuppliers.length === 0) return null;

        return {
          name,
          suppliers: sortedSuppliers,
          total: {
            grossPrice,
            markup,
            netPrice,
          },
        };
      })
      .filter(Boolean);
    const arr: any = [];
    const filterSupplier = pricingItems.filter((item: any) => item.name !== "null");

    filterSupplier.map((item: any) => {
      item?.suppliers?.map((supplier: any) => {
        supplier?.itemResourcesGrouped?.map((itemResource: any) => {
          itemResource?.resources?.map((resource: any) => {
            if (resourceIds.includes(resource.id)) {
              arr.push({ ...item, name: supplier?.name });
            }
          });
        });
      });
    });

    supplierData.value = [{ name: arr[0].name, suppliers: arr[0].suppliers }];
    supplierDataBackup.value = cloneDeep(supplierData.value);

    const anyUpdated = arr.some((item: any) =>
      item?.suppliers?.some((supplier: any) =>
        supplier?.itemResourcesGrouped?.some((group: any) =>
          group?.resources?.some((r: any) => r.isUpdatedBySupplier || r.reservationStatus === 'modified' || r.reservationStatus === 'complete')
        )
      )
    );
    if (anyUpdated) {
      emailUpdated.value = true;
    }
  }
};

const calculatePrice = (
  tourDayItemResources: TourDayItemResource[] | IPricingItemSupplierResource[]
): Record<string, any> => {
  const { netPrice, grossPrice } = calculatePriceGroup(tourDayItemResources);

  let markup: number = ((grossPrice - netPrice) * 100) / netPrice;

  markup = Math.round(markup * 100) / 100;

  if (Number.isNaN(markup)) {
    markup = 0;
  }

  return {
    netPrice,
    grossPrice,
    markup,
  };
};

const buildSavePayload = () => {
  return (
    supplierData.value?.flatMap((supplier: any) =>
      supplier.suppliers.flatMap((s: any) =>
        s.itemResourcesGrouped
          .filter((item: any) => item.resources?.length)
          .map((item: any) => ({
            resourceIds: item.resources.map((r: any) => r.id),
            qty: item.quantity,
            price: roundPrice(Number(item.netPrice) * item.quantity),
          }))
      )
    ) ?? []
  );
};

const confirm = async (type: "freeText" | "price" | "accept") => {
  const { caseid, resources, token } = route.query;

  // Normalize resource IDs → number[]
  const resourceIds = typeof resources === "string" ? resources.split(",").filter(Boolean).map(Number) : [];

  let payload;

  if (type === "price") {
    payload = {
      resourceIds,
      items: buildSavePayload(),
    };
  } else if (type === "freeText" && supplierObservation.value !== "") {
    payload = {
      resourceIds,
      observations: supplierObservation.value,
    };
  }

  try {
    if (type === "accept") {
      // Accept: just accept current prices as-is, no need to save modifications first
      await api.case.acceptEmail(caseid, token, { resourceIds });
    } else {
      await api.case.modificationEmail(caseid, token, payload);
    }
    sucessEmailUpdated.value = true;
    showPricingConfirmation.value = false;
  } catch (error: any) {
    console.error(error);
    sucessEmailUpdated.value = false;
    toast.error(error?.response?.data?.message || t("general.shared.errorMessage"));
  }
};

const confirmAccept = async () => {
  await confirm("accept");
};

const isHotelSupplier = (supplierName: any) => {
  return supplierName?.suppliers?.some((s: any) => s?.type === 'hotel') ?? false;
};
</script>

<style lang="scss" scoped>
.btn-modify {
  background-color: #E65C51 !important;
  border-color: #E65C51 !important;
  color: #FFFFFF !important;

  &:hover {
    background-color: #d14a40 !important;
    border-color: #d14a40 !important;
  }

  &:disabled {
    background-color: #f0a09a !important;
    border-color: #f0a09a !important;
    opacity: 0.7;
  }
}

.btn-edit-price {
  background-color: #E6B328 !important;
  border-color: #E6B328 !important;
  color: #FFFFFF !important;

  &:hover {
    background-color: #cc9f1f !important;
    border-color: #cc9f1f !important;
  }

  &:disabled {
    background-color: #f0d690 !important;
    border-color: #f0d690 !important;
    opacity: 0.7;
  }
}

.btn-save-confirm {
  background-color: #26D0A1 !important;
  border-color: #26D0A1 !important;
  color: #FFFFFF !important;

  &:hover {
    background-color: #1eb88c !important;
    border-color: #1eb88c !important;
  }
}

.btn-accept {
  background-color: #26D0A1 !important;
  border-color: #26D0A1 !important;
  color: #FFFFFF !important;

  &:hover {
    background-color: #1eb88c !important;
    border-color: #1eb88c !important;
  }
}

.accordion-toggle {
  cursor: pointer;
}

:deep(.custom-input-style) {
  .form-control {
    background-color: rgba(var(--uq-warning-rgb), 0.25);
    border-color: var(--uq-dragon);
  }

  .input-group-text {
    background-color: #f7f7fc;
  }

  .form-control + .input-group-text {
    border-color: var(--uq-dragon);
  }
}

.suppliers-header {
  .th {
    padding-left: 2.75rem !important;
  }
}

.suppliers-header,
.resources-profit-header {
  .th {
    padding: 0.5rem 0.375rem;
    font-weight: 500;
    font-size: 0.875rem;

    @media (min-width: 1400px) {
      font-size: 1rem;
    }
  }
}

.free-text {
  width: 80%;
  margin: 0 auto;

  @media screen and (max-width: 1250px) {
    width: 95%;
  }

  @media screen and (max-width: 992px) {
    width: 90%;
  }
}

.supplier-container {
  border: 1px solid var(--uq-gray-400);
  border-radius: 0.25rem;
  margin: 0 auto;
  width: 80%;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  @media screen and (max-width: 1250px) {
    width: 95%;
  }

  @media screen and (max-width: 992px) {
    width: 90%;
  }
}

.supplier-data {
  position: relative;

  .td {
    padding-inline: 0.375rem;
    font-weight: 300;
  }
}

.supplier-name {
  font-size: 0.875rem;

  @media (min-width: 992px) {
    font-size: 1rem;
  }

  @media (min-width: 1200px) {
    font-size: 1.125rem;
  }
}

.row {
  padding: 0.375rem;
  font-size: 0.875rem;

  @media (min-width: 992px) {
    font-size: 1rem;
  }

  .td {
    padding-inline: 0.375rem;
    font-weight: 300;
  }
}

.item-list {
  .resources-container {
    position: relative;
    margin-bottom: 1rem;
    padding-bottom: 1rem;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 100%;
      background: var(--uq-secondary);
    }
  }

  .type-total,
  .pricing-total {
    padding-block: 1rem;
    border: 1px solid var(--uq-gray-400);
    border-radius: 0.25rem;
  }
}

.image-container {
  flex: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  font-size: 1.5rem;
  color: var(--uq-light);
}

.spinner-border {
  position: fixed;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 1050;
}

.suppliers-body {
  .tour-day-item-resource-container,
  .wrapper {
    position: relative;
    padding-top: 0.75rem;

    &:not(:last-child) {
      padding-bottom: 0.75rem;
    }

    &:not(:last-child):after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 100%;
      background: var(--uq-gray-300);
    }

    &.bg-gray-200 {
      :deep(.form-outline .label span) {
        background-color: #f7f7fc !important;
      }

      :deep(.input-group .input-group-text) {
        background-color: #f0f0f9;
      }
    }

    :deep(.input-group .input-group-text) {
      background-color: #f7f7fc;
    }
  }

  .mobile-view {
    display: none;
  }

  .sub-container {
    width: 44%;
  }

  .form-check-inline {
    margin-top: 8px;
  }

  @media (max-width: 993px) {
    .normal-view {
      display: none;
    }

    .mobile-view {
      display: flex;
    }

    .sub-container {
      width: 100%;
      margin-left: 1rem;
      margin-top: 1rem;
    }
  }
}

.dashed:not(:last-child) {
  padding-bottom: 1rem;
  border-bottom: 1px dashed var(--uq-gray-400);
}

.accordion-toggle {
  .accordion-icon {
    right: 0.5rem;
  }
}

.table-container {
  display: table;
  width: 90%;
  margin: 0 auto;

  @media screen and (max-width: 992px) {
    width: 84%;
  }
}

.btn-container {
  display: table;
  width: 91.5%;
  margin: 0 auto;

  @media screen and (max-width: 1206px) {
    width: 94.5%;
  }

  @media screen and (max-width: 992px) {
    display: none;
    width: 85%;
  }
}

.row-header,
.row-data {
  display: table-row;
}

.product-info {
  display: flex;
  flex-wrap: wrap;
  align-self: center;
}

.warning-info {
  width: 25px;
  height: 25px;
  background: #dbdbdb;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;

  @media screen and (max-width: 992px) {
    width: 32px;
    height: 25px;
  }
}

.topright {
  top: -8px;
  right: 20px;
  font-size: 18px;
}

img,
.button-container {
  width: 100%;
  height: auto;
}

.accordion-toggle .accordion-icon {
  right: -2.5rem;

  @media screen and (max-width: 992px) {
    top: -1.8rem;
  }
}

.accordion-sub-body .row-data .th {
  font-weight: 300;
}

.accordion-toggle .accordion-icon {
  right: -2.5rem;

  @media screen and (max-width: 992px) {
    top: -1.8rem;
  }
}

.accordion-sub-body .row-data .th {
  font-weight: 300;
}

.row-data {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.warning-info {
  position: relative;
  display: flex;
  align-items: center;
}

/* Tooltip text */
.tooltip-text {
  visibility: hidden;
  width: 180px;
  background-color: black;
  color: white;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -88px;
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip text arrow */
.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

/* Show the tooltip text on hover */
.warning-info:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.warning-info {
  position: relative;
  display: flex;
  align-items: center;
}

/* Tooltip text */
.tooltip-text {
  visibility: hidden;
  width: 180px;
  background-color: black;
  color: white;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -88px;
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip text arrow */
.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

/* Show the tooltip text on hover */
.warning-info:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.dashed:not(:last-child) {
  padding-bottom: 1rem;
  border-bottom: 1px dashed var(--uq-gray-400);
}

.wrapper {
  position: relative;
  padding-top: 0.75rem;

  &:not(:last-child) {
    padding-bottom: 0.75rem;
  }

  &:not(:last-child):after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 100%;
    background: var(--uq-gray-300);
  }

  &.bg-gray-200 {
    :deep(.form-outline .label span) {
      background-color: #f7f7fc !important;
    }

    :deep(.input-group .input-group-text) {
      background-color: #f0f0f9;
    }
  }

  :deep(.input-group .input-group-text) {
    background-color: #f7f7fc;
  }
}
</style>
